import { LazyPage, PipelineSourceLayoutPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { sourceRouteParams } from '@/services/router/pipeline-route-params';

function PipelineSourceLayoutRoute() {
  return (
    <LazyPage>
      <PipelineSourceLayoutPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId')({
  params: sourceRouteParams,
  component: PipelineSourceLayoutRoute,
});
